import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  DeleteLegalEntityClientModel,
  SearchLegalEntityClientModel,
} from '../../../models/customer.model'
import { SearchPersonLegalModel } from '../../../models/person.model'

@Injectable({
  providedIn: 'root',
})
export class LegalEntityClientService {
  private baseUrl = environment.baseUrl
  private resource = 'ClientePessoaJuridica'

  constructor(private httpClient: HttpClient) {}

  public createLegalEntityClient(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editLegalEntityClient(
    model: any,
    // model: EditLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteLegalEntityClient(
    model: DeleteLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public deleteClient(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedLegalEntityClient(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/associado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedNotLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/desassociado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listLegalEntityClient(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getLegalEntityClientbyId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedLegalEntityClient(
    page: number,
    rows = 15,
    model: SearchLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedLegalEntityClientAssociateBySubClient(
    page: number,
    rows = 15,
    model: SearchLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/associado-subcliente?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPagedClientSubClient(
    page = 1,
    rows = 15,
    filter: 1 | 2 | 3 = 3,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/filter?pageNumber=${page}&pageSize=${rows}&filter=${filter}`,
    )
  }

  public searchPagedClientSubClient(
    page = 1,
    rows = 15,
    model: SearchPersonLegalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/filter?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public createClientTooSupplier(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/from-fornecedor`,
      model,
    )
  }

  public searchPagedClientNew(
    page = 1,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/convert/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
